<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>How will I receive payment?<Caret /></summary>
  <p>
    Payment is by bank transfer to your bank account. Please enter your bank details using our secure portal.
  </p>
</details>
